import { ele } from "cables-shared-client";
import api from "../api.js";
import web from "../index.js";

export default class PageLanding
{
    constructor(targetElement)
    {
        this._settings = {
            "sloganTimer": -1,
            "scene": null
        };

        // (targetEl, demosJson)
        const demosJson = targetElement.dataset.demosjson;
        const demos = web.parseDustJson(demosJson, []);
        let demoIndex = Math.floor(Math.random() * demos.length);
        document.getElementById("demoiframe").src = "/api/demo/" + demoIndex;

        this.resize();

        ele.byQuery("body").innerHTML += "<link href=\"https://fonts.googleapis.com/css?family=Ubuntu\" rel=\"stylesheet\" type=\"text/css\"/>\n";
        window.addEventListener("resize", this.resize.bind(this), false);
        this.resize();

        const demoContainer = ele.byId("democontainer");
        if (demoContainer)
        {
            demoContainer.addEventListener("pointerenter", () =>
            {
                this.hideSlogan();
            });
            demoContainer.addEventListener("pointerleave", () =>
            {
                this._settings.sloganTimer = setTimeout(() => { ele.show(ele.byQuery(".slogan")); }, 1000);
            });
        }
        this.landingPatchteaser();
    }

    resize()
    {
        let switcher = document.getElementById("demoswitcher");
        let m = document.getElementById("democontainer");
        let iframe = document.getElementById("demoiframe");

        let w = m.getBoundingClientRect().width;
        let h = w * 8 / 20;

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
            h = w * 3 / 3;

        m.style.height = h + "px";

        iframe.style.height = h + "px";
        iframe.style.width = w + "px";

        if (switcher)switcher.style.top = h + "px";

        if (this._settings.scene) this._settings.scene.cgl.updateSize();
        else setTimeout(this.resize.bind(this), 100);
    }

    hideSlogan()
    {
        if (this._settings.sloganTimer !== -1)clearTimeout(this._settings.sloganTimer);
        this._settings.sloganTimer = -1;
        const slogan = ele.byQuery(".slogan");
        if (slogan) ele.hide(slogan);
    }

    landingPatchteaser()
    {
        api.get("fav/top", (result) =>
        {
            let i = 0;
            let favHtml = web.getHandleBarHtml("project_list_headline", {
                "link": "/ops",
                "title": ""
            });
            favHtml += "<div class=\"row\">";

            if (result.topFavs.length > 4) result.topFavs.length = 4;
            for (i in result.topFavs)
            {
                const project = result.topFavs[i].proj;
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": "published" });
                favHtml += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            favHtml += "</div>";
            document.getElementById("landingteaser").innerHTML = favHtml;

            let allTimeHtml = web.getHandleBarHtml("project_list_headline", {
                "link": "/ops",
                "title": ""
            });
            allTimeHtml += "<div class=\"row\">";
            if (result.allTimeTop.length > 4) result.allTimeTop.length = 4;
            for (i in result.allTimeTop)
            {
                const project = result.allTimeTop[i].proj;
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": "published" });
                allTimeHtml += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            allTimeHtml += "</div>";
            document.getElementById("landingteaser2").innerHTML = allTimeHtml;
        });
    }
}
